import { ScreeningCheckStatus } from 'common/types/services/api/offers/offer-item-dto.type';
import { Modal } from 'components/organisms/Modal';
import { useWindowSize } from 'hooks';
import { Button, RadioButton } from 'legacy-components/componets';

interface Props {
  paidByScreeningStatus: ScreeningCheckStatus;
  onSelect: (status: ScreeningCheckStatus) => void;
  onAccept: () => void;
  onClose: () => void;
  isOpen: boolean;
  totalPrice: number;
}

const SelectTenantScreeningPayerDialog = ({ paidByScreeningStatus, onSelect, onAccept, onClose, isOpen, totalPrice }: Props) => {
  const { isMobile } = useWindowSize();

  const getPayerList = () => [
    { title: `Listing Landlord $(${totalPrice})`, value: ScreeningCheckStatus.RequestedLandlord },
    { title: `Prospective Renter $(${totalPrice})`, value: ScreeningCheckStatus.RequestedRenter }
  ]

  const getButtonTitle = (status: ScreeningCheckStatus) => ({ 
    [ScreeningCheckStatus.RequestedLandlord]: `Accept and pay $(${totalPrice})`,
    [ScreeningCheckStatus.RequestedRenter]: 'Accept and Send to Renter ',
  }[status]);

  return (
    <Modal
      title={'Pay For Background Check'}
      isOpen={isOpen}
      isFullScreen={isMobile}
      contentClassName={'w-[550px]'}
      onOpenChange={(open) => {
        if (open) return;
        onClose();
      }}
    >
      <div className='flex flex-col gap-6'>
      <div className='text-[16px] py-3 text-neutral-800 font-bold'>Please select who should pay for the Background Check</div>
        <div className="space-y-2">
          {getPayerList().map((item) => (
            <RadioButton key={item.title} 
              name={item.title}
              theme='selectable'
              rightAligned={true}
              label={item.title}
              value={item.value}
              checked={paidByScreeningStatus === item.value}
              onChange={() => onSelect(item.value)} />
          ))}
        </div>
        
        <Button className='mt-4' label={getButtonTitle(paidByScreeningStatus)} theme={'primary'} onClick={onAccept} />
      </div>
      
    </Modal>
  )
}

export default SelectTenantScreeningPayerDialog